import { useDataProvider } from '@work4all/data';

import { TaxGroup } from '@work4all/models/lib/Classes/TaxGroup.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const TAX_GROUPS_REQUEST: DataRequest = {
  operationName: 'GetTaxGroups',
  data: { id: null, name: null },
  entity: Entities.taxGroup,
  completeDataResponse: true,
  vars: {
    includeStaticGroups: true,
  },
};

export const useTaxGroups = (): TaxGroup[] => {
  const { data } = useDataProvider<TaxGroup>(TAX_GROUPS_REQUEST);
  return data;
};
